var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":"20","width":"2"}}):_c('span',[_vm._v(" "+_vm._s(_vm.communityName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }